import React, { Component } from 'react';

export default class Options extends Component {
  render() {
    return (
      <table className="options">
        <thead>
          <tr>
            <th>Property</th>
            <th>Type</th>
            <th>Default</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>className</td>
            <td>string</td>
            <td>undefined</td>
            <td>Adds a given class to <code>.imagebox-wrapper</code>.</td>
          </tr>
          <tr>
            <th colSpan="4" className="options-type">Transition</th>
          </tr>
          <tr>
            <td>overlayOpacity</td>
            <td>number</td>
            <td>0.75</td>
            <td>The opacity level of overlay. Avaliable range: 0 to 1.</td>
          </tr>
          <tr>
            <td>overlayClose</td>
            <td>boolean</td>
            <td>true</td>
            <td>If true, Imagebox will close when clicking overlay area.</td>
          </tr>
          <tr>
            <td>escClose</td>
            <td>boolean</td>
            <td>true</td>
            <td>If true, Imagebox will close when press esc key.</td>
          </tr>
          <tr>
            <td>fadeIn</td>
            <td>boolean</td>
            <td>false</td>
            <td>If true, Imagebox will open with fade-in transition.</td>
          </tr>
          <tr>
            <td>fadeInSpeed</td>
            <td>number</td>
            <td>500</td>
            <td>Sets the speed of the fade-in transition.</td>
          </tr>
          <tr>
            <td>fadeOut</td>
            <td>boolean</td>
            <td>true</td>
            <td>If true, Imagebox will close with fade-out transition.</td>
          </tr>
          <tr>
            <td>fadeOutSpeed</td>
            <td>number</td>
            <td>500</td>
            <td>Sets the speed of the fade-out transition.</td>
          </tr>

          <tr>
            <th colSpan="4" className="options-type">Title bar</th>
          </tr>
          <tr>
            <td>titleBar.enable</td>
            <td>boolean</td>
            <td>false</td>
            <td>If true, Popupbox will includes a title bar.</td>
          </tr>
          <tr>
            <td>titleBar.className</td>
            <td>string</td>
            <td>undefined</td>
            <td>Adds a given class to title bar.</td>
          </tr>
          <tr>
            <td>titleBar.text</td>
            <td>string</td>
            <td>undefined</td>
            <td>Defined the text of title bar.</td>
          </tr>
          <tr>
            <td>titleBar.closeButton</td>
            <td>boolean</td>
            <td>true</td>
            <td>If false, remove close button.</td>
          </tr>
          <tr>
            <td>titleBar.closeButtonClassName</td>
            <td>string</td>
            <td>undefined</td>
            <td>Adds a given class to close button.</td>
          </tr>
          <tr>
            <td>titleBar.closeText</td>
            <td>string</td>
            <td>✕</td>
            <td>Defined the text of close button.</td>
          </tr>
          <tr>
            <td>titleBar.position</td>
            <td>'top' or 'bottom'</td>
            <td>'top'</td>
            <td>Defined the relative position of title bar.</td>
          </tr>
          <tr>
            <td>titleBar.nextText</td>
            <td>String</td>
            <td>{'>'}</td>
            <td>Defined the text of next button.</td>
          </tr>
          <tr>
            <td>titleBar.prevText</td>
            <td>String</td>
            <td>{'<'}</td>
            <td>Defined the text of prev button.</td>
          </tr>

          <tr>
            <th colSpan="4" className="options-type">Lightbox</th>
          </tr>
          <tr>
            <td>lightbox.speed</td>
            <td>number</td>
            <td>500</td>
            <td>Sets the speed of resize transition.</td>
          </tr>
          <tr>
            <td>lightbox.smoothResize</td>
            <td>boolean</td>
            <td>true</td>
            <td>If false, the wrapper will resize without transition animation.</td>
          </tr>
          <tr>
            <td>lightbox.fadeMode</td>
            <td>boolean</td>
            <td>true</td>
            <td>If false, the content will appear and hide without transition animation.</td>
          </tr>
          <tr>
            <td>lightbox.fadeSpeed</td>
            <td>number</td>
            <td>300</td>
            <td>Sets the speed of content fadeIn/fadeOut transition</td>
          </tr>
          <tr>
            <td>lightbox.loop</td>
            <td>boolean</td>
            <td>true</td>
            <td>If false, will disable loop back to the beginning when on the last content.</td>
          </tr>
          <tr>
            <td>lightbox.clickSwitch</td>
            <td>boolean</td>
            <td>true</td>
            <td>If false, click content will not go to next content.</td>
          </tr>
          <tr>
            <td>lightbox.compatible</td>
            <td>boolean</td>
            <td>false</td>
            <td>If true, content will compatible to browser's visible size. Note: only work for image content.</td>
          </tr>
          <tr>
            <td>lightbox.maxHeight</td>
            <td>number</td>
            <td>800</td>
            <td>Sets max-height of content.</td>
          </tr>
          <tr>
            <td>lightbox.maxWidth</td>
            <td>number</td>
            <td>100</td>
            <td>Sets max-width of content.</td>
          </tr>
          <tr>
            <td>lightbox.minHeight</td>
            <td>number</td>
            <td>0</td>
            <td>Sets min-height of content.</td>
          </tr>
          <tr>
            <td>lightbox.minWidth</td>
            <td>number</td>
            <td>0</td>
            <td>Sets min-width of content.</td>
          </tr>
          <tr>
            <td>lightbox.initWidth</td>
            <td>number</td>
            <td>200</td>
            <td>Sets initial width of content being loaded.</td>
          </tr>
          <tr>
            <td>lightbox.initHeight</td>
            <td>number</td>
            <td>200</td>
            <td>Sets initial height of content being loaded.</td>
          </tr>

          <tr>
            <th colSpan="4" className="options-type">Callback</th>
          </tr>
          <tr>
            <td>onOpen</td>
            <td>function</td>
            <td>undefined</td>
            <td>Callback that fires right before Imagebox begins to open.</td>
          </tr>
          <tr>
            <td>onComplete</td>
            <td>function</td>
            <td>undefined</td>
            <td>Callback that fires right after loaded content is displayed.</td>
          </tr>
          <tr>
            <td>onCleanup</td>
            <td>function</td>
            <td>undefined</td>
            <td>Callback that fires at the start of the close process.</td>
          </tr>
          <tr>
            <td>onClosed</td>
            <td>function</td>
            <td>undefined</td>
            <td>Callback that fires once Imagebox is closed.</td>
          </tr>
        </tbody>
      </table>
    )
  }
}



// WEBPACK FOOTER //
// ./components/options.js